import { describe, expect, it } from '@jest/globals';
import type { GeneratedPackageSettings } from '@ms-cloudpack/common-types';
import { getGeneratedPackageSettings } from './getGeneratedPackageSettings.js';

describe('getGeneratedPackageSettings', () => {
  it('returns undefined if no package settings are defined', () => {
    const result1 = getGeneratedPackageSettings({
      name: 'test',
      version: '1.0.0',
      generatedPackageSettings: undefined,
    });
    expect(result1).toBeUndefined();

    const result2 = getGeneratedPackageSettings({
      name: 'test',
      version: '1.0.0',
      generatedPackageSettings: [],
    });
    expect(result2).toBeUndefined();
  });

  it('returns undefined if no settings match', () => {
    const result = getGeneratedPackageSettings({
      name: 'test',
      version: '1.0.0',
      generatedPackageSettings: [{ match: 'foo' }, { match: { name: 'test', version: '^2.0.0' } }],
    });
    expect(result).toBeUndefined();
  });

  it('works with string match', () => {
    const generatedPackageSettings: GeneratedPackageSettings[] = [{ match: 'foo' }, { match: 'test' }];
    const result = getGeneratedPackageSettings({
      name: 'test',
      version: '1.2.3',
      generatedPackageSettings,
    });

    // check reference equality (currently we mutate the returned object to update settings)
    expect(result).toBe(generatedPackageSettings[1]);
  });

  it('works with name/version match', () => {
    const generatedPackageSettings: GeneratedPackageSettings[] = [
      { match: { name: 'test', version: '^2.0.0' } },
      { match: { name: 'test', version: '^1.0.0' } },
    ];
    const result = getGeneratedPackageSettings({
      name: 'test',
      version: '1.2.3',
      generatedPackageSettings,
    });

    // check reference equality (currently we mutate the returned object to update settings)
    expect(result).toBe(generatedPackageSettings[1]);
  });

  it('returns the most specific match', () => {
    const generatedPackageSettings: GeneratedPackageSettings[] = [
      { match: { name: 'test', version: '^2.0.0' } },
      { match: { name: 'test', version: '^1.0.0' } },
      { match: { name: 'test', version: '^1.1.0' } },
    ];
    const result = getGeneratedPackageSettings({
      name: 'test',
      version: '1.2.3',
      generatedPackageSettings,
    });

    // check reference equality (currently we mutate the returned object to update settings)
    expect(result).toBe(generatedPackageSettings[2]);
  });

  it('returns a match for a prerelease package', () => {
    const generatedPackageSettings: GeneratedPackageSettings[] = [
      { match: { name: 'test', version: '^1.0.0-beta.0' } },
    ];
    const result = getGeneratedPackageSettings({
      name: 'test',
      version: '1.0.0-beta.1',
      generatedPackageSettings,
    });

    // check reference equality (currently we mutate the returned object to update settings)
    expect(result).toBe(generatedPackageSettings[0]);
  });
});
